import { en } from './en'
import { fr } from './fr'

export const opportunityRequestModal = {
  en,
  fr
}